import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Overlay = styled(motion.div)`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 15vh;
`;

export const PaletteContainer = styled(motion.div)`
  width: 100%;
  max-width: 600px;
  background-color: #1a1b26;
  border: 1px solid rgba(122, 162, 247, 0.3);
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  /* 1. Hardcoded font to prevent serif bleeding from Art Mode */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 1.25rem 1.5rem;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  
  /* 2. Hardcoded to a light slate blue/white for visibility */
  color: #c0caf5; 
  font-size: 1.1rem;
  font-family: inherit;
  outline: none;

  &::placeholder {
    /* 3. Hardcoded placeholder color */
    color: #565f89; 
  }
`;

export const CommandList = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding: 0.5rem;
  scrollbar-width: thin;
  scrollbar-color: #414868 transparent;
  position: relative; 
`;

export const MagicInk = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.1); 
  border-radius: 8px;
  z-index: 0; 
  transition: all 0.2s cubic-bezier(0.25, 1, 0.5, 1);
  pointer-events: none; 
  
  top: ${props => props.top || 0}px;
  height: ${props => props.height || 0}px;
  
  left: 0.5rem;
  width: calc(100% - 1rem); 
  opacity: ${props => props.opacity};
`;

export const CommandItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background-color: transparent; 
  border: none;
  font-family: inherit;
  font-size: 0.95rem;
  cursor: pointer;
  text-align: left;
  outline: none;
  position: relative;
  z-index: 1; 
  
  /* 4. Hardcoded inactive color so it stays visible against the dark background */
  color: ${props => props.$active ? '#fff' : '#a9b1d6'};
  
  filter: ${props => props.$active ? 'blur(0px)' : 'blur(0.8px)'};
  opacity: ${props => props.$active ? 1 : 0.9};
  
  transition: color 0.2s ease, filter 0.2s ease, opacity 0.2s ease;
`;

export const CommandGroup = styled.div`
  padding: 0.5rem 1rem 0.25rem 1rem;
  font-size: 0.75rem;
  color: #565f89;
  /* 5. Removed var(--font-heading) to keep it consistent */
  font-family: inherit;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  position: relative;
  z-index: 1;
`;